import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { fetchSite } from '../actions/sites';
import { getSiteByKey } from '../selectors/sites';
import { fetchPage } from '../actions/page';
import { getPrimaryPage } from '../utils/site';

const DefaultPage = loadable(
  () => import(/* webpackChunkName: "connect" */ '../containers/DefaultPage'),
  {
    fallback: Loading
  }
);

DefaultPage.needs = async (props, { getState, dispatch }) => {
  await dispatch(fetchSite(props.params.site));

  const site = getSiteByKey(getState(), props.params.site);
  if (!site || !site.pages) return;
  const page = getPrimaryPage(site);

  return page && dispatch(fetchPage(page.id));
};

export default DefaultPage;
